<template>
  <div>
    <section
      class="section-title-page container-fluid"
      style="background-image: url('/img/bg_tramite.jpg')"
    >
      <div class="container">
        <div class="wrapper">
          <h1>Sobre <small style="font-weight: 300">Nosotros</small></h1>
          <span>
            Volver <i class="fa fa-angle-right mx-1"></i>
            <a href="/">Inicio</a>
          </span>
        </div>
      </div>
    </section>
    <section class="section-page container-fluid pb-0">
      <div class="institutional container">
        <div class="wrapper">
          <div class="text">
            <h4 class="">Consejo Departamental</h4>
            <h3>San Martín</h3>
            <div class="description">
              <p v-html="Institucion.descripcion_consejo"></p>
            </div>
          </div>
          <div class="image">
            <img :src="Institucion.imagen_consejo" alt="" />
          </div>
        </div>
      </div>
      <div class="mision-vision container">
        <div class="wrapper">
          <div class="col-md-6">
            <div class="box">
              <div class="context">
                <h1><i class="fa fa-bullseye mr-2"></i>Misión</h1>
                <p v-html="Institucion.mision"></p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="box">
              <div class="context">
                <h1><i class="fa fa-eye mr-2"></i>Visión</h1>
                <p v-html="Institucion.vision"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="history p-2"
        style="background-image: url('/img/history.jpeg')"
      >
        <div class="container">
          <div class="banner-title">
            <h1>Historia</h1>
          </div>
          <div class="context">
            <p v-html="Institucion.historia"></p>
          </div>
        </div>
      </div>
      <div class="persons">
        <div class="container first">
          <div class="text-center my-5">
            <h1 class="section-title text-brown">Representantes</h1>
            <h6 class="section-subtitle">JUNTA DIRECTIVA 2024-2026</h6>
          </div>
          <div class="group">
            <div class="col-md-4" v-for="(value, k) in Representantes" :key="k">
              <div class="box">
                <div
                  class="img-person"
                  :style="{ 'background-image': 'url(' + value.foto + ')' }"
                ></div>
                <div class="text">
                  <h3>{{ value.nombres }}</h3>
                  <p class="m-0">CMVP: {{ value.numero_colegiatura }}</p>
                  <span>{{ value.cargo }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="text-center my-5">
          <h1 class="section-title text-brown">Consejo Nacional</h1>
          <h6 class="section-subtitle">PERIODO 2024-2026</h6>
        </div>
        <img
          style="
            border-radius: 8px;
            overflow: hidden;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
          "
          :src="Institucion.imagen_asamblea"
          alt=""
        />
      </div>
      <div class="persons container-fluid bg-black">
        <div class="container second">
          <div class="text-center py-5">
            <h1 class="section-title text-white">Past Decanos</h1>
            <h6 class="section-subtitle">Antiguos Decanos</h6>
          </div>
          <div class="group">
            <div
              class="col-md-4"
              v-for="(value, k) in AnterioresDecanos"
              :key="k"
            >
              <div class="box">
                <div
                  class="img-person"
                  :style="{ 'background-image': 'url(' + value.foto + ')' }"
                ></div>
                <div class="text">
                  <span>{{ value.periodo }}</span>
                  <h3>{{ value.nombres }}</h3>
                  <p class="m-0">CMVP: {{ value.numero_colegiatura }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
  
  <script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "nosotros",
  computed: {
    ...mapState(["empresa"]),
  },
  created() {},
  mounted() {
    this.getAbout();
  },
  data() {
    return {
      About: {},
      Institucion: [],
      Representantes: [],
      AnterioresDecanos: [],
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getAbout() {
      this.setLoading(true);
      this.$http.get("ws_about/about").then((res) => {
        this.About = res.data;
        this.Institucion = res.data.Institucion;
        this.Representantes = res.data.Representantes;
        this.AnterioresDecanos = res.data.Anteriores_decanos;
        console.log("res.data");
        console.log(res.data);
        this.setLoading(false);
      });
    },
  },
};
</script>